export const arrOptionNumber = [
  {
    label: "1",
    value: "1",
  },
  {
    label: "2",
    value: "2",
  },
  {
    label: "3",
    value: "3",
  },
  {
    label: "4",
    value: "4",
  },
  {
    label: "5",
    value: "5",
  },
  {
    label: "6",
    value: "6",
  },
  {
    label: "7",
    value: "7",
  },
  {
    label: "8",
    value: "8",
  },
  {
    label: "9",
    value: "9",
  },
];

export const StatusOptionDropdown = [
  {
    label: "Active",
    value: true,
  },
  {
    label: "Disable",
    value: false,
  },
];

export const CouponStatusOptionDropdown = [
  {
    label: "Active",
    value: "active",
  },
  {
    label: "Disable",
    value: "expired",
  },
];
export const lockerStatusOptionDropdown = [
  {
    label: "Active",
    value: "active",
  },
    {
    label:"Review",
    value:"review",
  },
  {
    label: "Draft",
    value: "draft",
  },

];
export const DeclarationStatusOptionDropdown = [
  {
    label: "Active",
    value: "active",
  },
  {
    label: "Draft",
    value: "draft",
  },
];
export const DeclarationTypeOptionDropdown = [
  {
    label: "Import",
    value: "import",
  },
  {
    label: "Export",
    value: "export",
  },
  {
    label: "Both",
    value: "both",
  },
];
 export const NotificationOptionDropdown = [
  {
    label: "Email",
    value: "email",
  },
  {
    label: "Push",
    value: "push",
  },
  {
    label: "SMS",
    value: "sms",
  },
];
export const lockerOptionDropdown = [
  {
    label: "Import",
    value: "import",
  },
  {
    label: "Export",
    value: "export",
  },
  {
    label: "Both",
    value: "both",
  },
];

export const arrOptionSize = [
  { label: "SMALL", value: "small" },
  { label: "LARGE", value: "large" },
  { label: "MEDIUM", value: "medium" },
];
export const videoOption = [
  { label: "YES", value: "yes" },
  { label: "NO", value: "no" },
];
export const selfDropTimeOptions = [
  { label: "09:00 AM - 12:00 PM", value: "09:00-12:00" },
  { label: "12:00 PM - 03:00 PM", value: "12:00-15:00" },
  { label: "03:00 PM - 06:00 PM", value: "15:00-18:00" },
  { label: "06:00 PM - 09:00 PM", value: "18:00-21:00" },
];
export const timeOptions = [
  { label: "12:00 AM", value: "00:00" },
  { label: "1:00 AM", value: "01:00" },
  { label: "2:00 AM", value: "02:00" },
  { label: "3:00 AM", value: "03:00" },
  { label: "4:00 AM", value: "04:00" },
  { label: "5:00 AM", value: "05:00" },
  { label: "6:00 AM", value: "06:00" },
  { label: "7:00 AM", value: "07:00" },
  { label: "8:00 AM", value: "08:00" },
  { label: "9:00 AM", value: "09:00" },
  { label: "10:00 AM", value: "10:00" },
  { label: "11:00 AM", value: "11:00" },
  { label: "12:00 PM", value: "12:00" },
  { label: "1:00 PM", value: "13:00" },
  { label: "2:00 PM", value: "14:00" },
  { label: "3:00 PM", value: "15:00" },
  { label: "4:00 PM", value: "16:00" },
  { label: "5:00 PM", value: "17:00" },
  { label: "6:00 PM", value: "18:00" },
  { label: "7:00 PM", value: "19:00" },
  { label: "8:00 PM", value: "20:00" },
  { label: "9:00 PM", value: "21:00" },
  { label: "10:00 PM", value: "22:00" },
  { label: "11:00 PM", value: "23:00" },
];
